import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { SnackbarContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';

interface NotificationSnackbarProps {
	open: boolean;
	onClose: () => void;
	title: string;
	description: string;
	success?: boolean;
}

export const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
	open,
	onClose,
	title,
	description,
	success = false,
}) => {
	return (
		<Snackbar
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={open}
			onClose={onClose}
			autoHideDuration={6000}
		>
			<SnackbarContent
				sx={{
					background: '#FFF',
					borderRadius: '8px',
					boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
					padding: '20px',
					'& .MuiSnackbarContent-message': {
						padding: 0,
					},
				}}
				message={
					<div>
						<div className="flex justify-between items-center">
							<div className="flex justify-center items-center">
								{success ? (
									<CheckCircleOutlineIcon sx={{ color: '#00AB89' }} />
								) : (
									<ErrorOutlineOutlinedIcon sx={{ color: '#FD3333' }} />
								)}
								<span
									className="text-[16px] font-[700] ml-[8px]"
									style={{ color: success ? '#00AB89' : '#FD3333' }}
								>
									{title}
								</span>
							</div>
							<IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
								<CloseIcon sx={{ color: '#7B809A', fontSize: '24px' }} fontSize="small" />
							</IconButton>
						</div>
						<div className="border-b border-[#E9ECEF] mt-[12px] mb-[14px]"></div>
						<div className="text-secondary text-[16px] font-[400]">{description}</div>
					</div>
				}
			/>
		</Snackbar>
	);
};
